import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsxs("g", {
        clipPath: "url(#fj670ktdp__clip0_1_83090)",
        children: [_jsx("rect", {
          width: "20",
          height: "20",
          rx: "10",
          fill: "white"
        }), _jsxs("g", {
          clipPath: "url(#yg42iye9r__clip1_1_83090)",
          children: [_jsx("path", {
            d: "M30 1H-3V20H30V1Z",
            fill: "#B22234"
          }), _jsx("path", {
            d: "M-3 3.19202H30H-3ZM30 6.11591H-3H30ZM-3 9.03804H30H-3ZM30 11.9619H-3H30ZM-3 14.8841H30H-3ZM30 17.8079H-3Z",
            fill: "black"
          }), _jsx("path", {
            d: "M30 18.5382H-3V17.0762H30V18.5382ZM30 15.616H-3V14.1541H30V15.616ZM30 12.6921H-3V11.2302H30V12.6921ZM30 9.77H-3V8.30806H30V9.77ZM30 6.84611H-3V5.38417H30V6.84611ZM30 3.92398H-3V2.46204H30V3.92398Z",
            fill: "white"
          }), _jsx("path", {
            d: "M11.1075 1H-3V11.2301H11.1075V1Z",
            fill: "#3C3B6E"
          }), _jsx("path", {
            d: "M0.527012 1.43799L0.863887 2.4953L-0.0161133 1.84086H1.06842L0.188418 2.4953L0.527012 1.43799Z",
            fill: "white"
          }), _jsx("path", {
            d: "M0.527012 3.48407L0.863887 4.54138L-0.0161133 3.88694H1.06842L0.188418 4.54138L0.527012 3.48407Z",
            fill: "white"
          }), _jsx("path", {
            d: "M0.527012 5.53003L0.863887 6.58734L-0.0161133 5.9329H1.06842L0.188418 6.58734L0.527012 5.53003Z",
            fill: "white"
          }), _jsx("path", {
            d: "M0.527012 7.57611L0.863887 8.63343L-0.0161133 7.97898H1.06842L0.190137 8.63519L0.527012 7.57611Z",
            fill: "white"
          }), _jsx("path", {
            d: "M0.527012 9.6239L0.863887 10.6812L-0.0161133 10.0268H1.06842L0.188418 10.6812L0.527012 9.6239Z",
            fill: "white"
          }), _jsx("path", {
            d: "M1.70401 2.46204L2.04089 3.51935L1.16089 2.86491H2.24542L1.36542 3.51935L1.70401 2.46204Z",
            fill: "white"
          }), _jsx("path", {
            d: "M1.70401 4.50793L2.04089 5.56525L1.16089 4.91081H2.24542L1.36542 5.56525L1.70401 4.50793Z",
            fill: "white"
          }), _jsx("path", {
            d: "M1.70401 6.55408L2.04089 7.61139L1.16089 6.95695H2.24542L1.36542 7.61139L1.70401 6.55408Z",
            fill: "white"
          }), _jsx("path", {
            d: "M1.70401 8.59998L2.04089 9.65729L1.16089 9.00285H2.24542L1.36542 9.65729L1.70401 8.59998Z",
            fill: "white"
          }), _jsx("path", {
            d: "M2.8765 1.43799L3.21337 2.4953L2.33337 1.84086H3.41791L2.53791 2.4953L2.8765 1.43799Z",
            fill: "white"
          }), _jsx("path", {
            d: "M2.8765 3.48407L3.21337 4.54138L2.33337 3.88694H3.41791L2.53791 4.54138L2.8765 3.48407Z",
            fill: "white"
          }), _jsx("path", {
            d: "M2.8765 5.53003L3.21337 6.58734L2.33337 5.9329H3.41791L2.53791 6.58734L2.8765 5.53003Z",
            fill: "white"
          }), _jsx("path", {
            d: "M2.8765 7.57611L3.21337 8.63343L2.33337 7.97898H3.41791L2.53962 8.63519L2.8765 7.57611Z",
            fill: "white"
          }), _jsx("path", {
            d: "M2.8765 9.6239L3.21337 10.6812L2.33337 10.0268H3.41791L2.53791 10.6812L2.8765 9.6239Z",
            fill: "white"
          }), _jsx("path", {
            d: "M4.05356 2.46204L4.39044 3.51935L3.51044 2.86491H4.59669L3.71669 3.51935L4.05356 2.46204Z",
            fill: "white"
          }), _jsx("path", {
            d: "M4.05356 4.50793L4.39044 5.56525L3.51044 4.91081H4.59669L3.71669 5.56525L4.05356 4.50793Z",
            fill: "white"
          }), _jsx("path", {
            d: "M4.05356 6.55408L4.39044 7.61139L3.51044 6.95695H4.59669L3.71669 7.61139L4.05356 6.55408Z",
            fill: "white"
          }), _jsx("path", {
            d: "M4.05356 8.59998L4.39044 9.65729L3.51044 9.00285H4.59669L3.71669 9.65729L4.05356 8.59998Z",
            fill: "white"
          }), _jsx("path", {
            d: "M5.23063 1.43799L5.5675 2.4953L4.6875 1.84086H5.77203L4.89203 2.4953L5.23063 1.43799Z",
            fill: "white"
          }), _jsx("path", {
            d: "M5.23063 3.48407L5.5675 4.54138L4.6875 3.88694H5.77203L4.89203 4.54138L5.23063 3.48407Z",
            fill: "white"
          }), _jsx("path", {
            d: "M5.23063 5.53003L5.5675 6.58734L4.6875 5.9329H5.77203L4.89203 6.58734L5.23063 5.53003Z",
            fill: "white"
          }), _jsx("path", {
            d: "M5.23063 7.57611L5.5675 8.63343L4.6875 7.97898H5.77203L4.89203 8.63519L5.23063 7.57611Z",
            fill: "white"
          }), _jsx("path", {
            d: "M5.23063 9.6239L5.5675 10.6812L4.6875 10.0268H5.77203L4.89203 10.6812L5.23063 9.6239Z",
            fill: "white"
          }), _jsx("path", {
            d: "M6.40341 2.46204L6.74028 3.51935L5.862 2.86491H6.94653L6.06653 3.51935L6.40341 2.46204Z",
            fill: "white"
          }), _jsx("path", {
            d: "M6.40311 4.50793L6.73998 5.56525L5.85999 4.91081H6.94451L6.06452 5.56525L6.40311 4.50793Z",
            fill: "white"
          }), _jsx("path", {
            d: "M6.40311 6.55408L6.73998 7.61139L5.85999 6.95695H6.94451L6.06452 7.61139L6.40311 6.55408Z",
            fill: "white"
          }), _jsx("path", {
            d: "M6.40311 8.59998L6.73998 9.65729L5.85999 9.00285H6.94451L6.06452 9.65729L6.40311 8.59998Z",
            fill: "white"
          }), _jsx("path", {
            d: "M7.58091 1.43799L7.91778 2.4953L7.03778 1.84262H8.12231L7.24403 2.49706L7.58091 1.43799Z",
            fill: "white"
          }), _jsx("path", {
            d: "M7.58091 3.48407L7.91778 4.54139L7.03778 3.8887H8.12231L7.24403 4.54314L7.58091 3.48407Z",
            fill: "white"
          }), _jsx("path", {
            d: "M7.58091 5.53003L7.91778 6.58735L7.03778 5.93466H8.12231L7.24403 6.58911L7.58091 5.53003Z",
            fill: "white"
          }), _jsx("path", {
            d: "M7.58091 7.57611L7.91778 8.63343L7.03778 7.98074H8.12231L7.24403 8.63519L7.58091 7.57611Z",
            fill: "white"
          }), _jsx("path", {
            d: "M7.58091 9.6239L7.91778 10.6812L7.03778 10.0268H8.12231L7.24403 10.6812L7.58091 9.6239Z",
            fill: "white"
          }), _jsx("path", {
            d: "M8.75797 2.46204L9.09484 3.51935L8.21484 2.86491H9.29937L8.41938 3.51935L8.75797 2.46204Z",
            fill: "white"
          }), _jsx("path", {
            d: "M8.75797 4.50793L9.09484 5.56525L8.21484 4.91081H9.29937L8.41938 5.56525L8.75797 4.50793Z",
            fill: "white"
          }), _jsx("path", {
            d: "M8.75797 6.55408L9.09484 7.61139L8.21484 6.95695H9.29937L8.41938 7.61139L8.75797 6.55408Z",
            fill: "white"
          }), _jsx("path", {
            d: "M8.75797 8.59998L9.09484 9.65729L8.21484 9.00285H9.29937L8.41938 9.65729L8.75797 8.59998Z",
            fill: "white"
          }), _jsx("path", {
            d: "M9.92996 1.43799L10.2685 2.49706L9.38855 1.84262H10.4731L9.59308 2.49706L9.92996 1.43799Z",
            fill: "white"
          }), _jsx("path", {
            d: "M9.93045 3.48407L10.2673 4.54138L9.38733 3.88694H10.4719L9.59186 4.54138L9.93045 3.48407Z",
            fill: "white"
          }), _jsx("path", {
            d: "M9.93045 5.53003L10.2673 6.58734L9.38733 5.9329H10.4719L9.59186 6.58734L9.93045 5.53003Z",
            fill: "white"
          }), _jsx("path", {
            d: "M9.92996 7.57611L10.2685 8.63519L9.38855 7.98074H10.4731L9.59308 8.63519L9.92996 7.57611Z",
            fill: "white"
          }), _jsx("path", {
            d: "M9.93045 9.6239L10.2673 10.6812L9.38733 10.0268H10.4719L9.59186 10.6812L9.93045 9.6239Z",
            fill: "white"
          })]
        })]
      }), _jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "19",
        height: "19",
        rx: "9.5",
        stroke: "#152361"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "fj670ktdp__clip0_1_83090",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            rx: "10",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "yg42iye9r__clip1_1_83090",
          children: _jsx("rect", {
            width: "33",
            height: "19",
            fill: "white",
            transform: "translate(-3 1)"
          })
        })]
      })]
    }))
  });
};
export default Component;
